import type { HttpClient } from './HttpClient';
import type { ICustomModuleCreated } from './ICustomModuleCreated';
import type { ICustomModuleWrite } from './ICustomModuleWrite';

const path = (ws: string, key?: string) => `/workspaces/${ws}/custom-modules${key ? `/${encodeURIComponent(key)}` : ''}`;

/**
 * Власні модулі робочого простору (ADR-025, конструктор модулів «+ Новий модуль» / «Видалити модуль»): створення за шаблоном прототипу
 * (статуси «Відкрито · У роботі · Готово», поля moduleTpl, подання table/cards/inline/backlog/split), зміна назви, однини, префікса,
 * категорії й опису та видалення разом із записами (можливість customize, подія аудиту). Поля, подання й форми власного модуля
 * змінюються перевизначеннями ADR-023, як у будь-якого типу запису.
 */
export class CustomModuleDao {
  constructor(private readonly http: HttpClient) {}

  create(ws: string, body: ICustomModuleWrite): Promise<ICustomModuleCreated> { return this.http.post(path(ws), body); }
  update(ws: string, key: string, body: ICustomModuleWrite): Promise<unknown> { return this.http.patch(path(ws, key), body); }
  remove(ws: string, key: string): Promise<void> { return this.http.delete(path(ws, key)); }
}
